<template>
  <section class="demo">
    <div class="column is-6">
      <div class="sub_inner">
        <h3>{{$t('train_up')}}<br />{{$t('trade_up')}}</h3>
        <p>{{$t('train_text_1')}}<br /><br />{{$t('train_text_2')}}</p>
        <ul>
          <li>{{$t('train_list_item_1')}}</li>
          <li>{{$t('train_list_item_2')}}</li>
          <li>{{$t('train_list_item_3')}}</li>
          <li>{{$t('train_list_item_4')}}</li>
        </ul>
      </div>
    </div>
    <div class="step column is-6 form-column">

      <h2 class="form_title">{{$t('form_title_1')}}<br />{{$t('form_title_2')}} <span>{{$t('form_title_3').tUpper()}}</span></h2>
      <p class="form_subtitle">{{$t('form_subtitle')}}</p>
      <div class="columns">
        <!-- <div class="column is-2">
          <label class="label" for="title">{{translations.text.title}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('title') }"
                :data-vv-as="translations.text.title"
                name="title"
                v-model="body.title"
              >
                <option value></option>
                <option v-for="(item, index) in titles" :value="index" :key="index">{{item}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('title')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('title') }}</span>
          </p>
        </div> -->
        <div class="column">
          <label
            class="label"
            for="firstname"
          >{{translations.text.firstname}}</label>
          <p class="control">
            <input
              v-validate="'required|alpha_spaces'"
              :class="{'input': true, 'is-danger': errors.has('firstname') }"
              name="firstname"
              type="text"
              :data-vv-as="translations.text.firstname"
              :placeholder="translations.text.firstname"
              v-model="body.firstname"
            />
            <span
              v-show="errors.has('firstname')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('firstname') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="lastname"
          >{{translations.text.lastname}}</label>
          <p class="control">
            <input
              v-validate="'required|alpha_spaces'"
              :class="{'input': true, 'is-danger': errors.has('lastname') }"
              name="lastname"
              type="text"
              :data-vv-as="translations.text.lastname"
              :placeholder="translations.text.lastname"
              v-model="body.lastname"
            />
            <span
              v-show="errors.has('lastname')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('lastname') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="email"
          >{{translations.text.email}}</label>
          <p class="control">
            <input
              v-validate="'required|email|email-available'"
              :class="{'input': true, 'is-danger': errors.has('email') }"
              name="email"
              type="text"
              :data-vv-as="translations.text.email"
              :placeholder="translations.text.email"
              v-model="body.email"
            />
            <span
              v-show="errors.has('email')"
              class="help is-danger"
            >{{ errors.first('email') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">

        <!-- <div class="column is-one-quarter">
					<label class="label" for="dialCode">{{$t('dial_code').tUpper()}}</label>
					<p class="control">
						<img class="flag" :class="'flag-'+body.country.toLowerCase()">
						<input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('dialCode') }" class="dialCode" name="dialCode" type="text" :data-vv-as="$t('dial_code')" :placeholder="$t('dial_code')" v-model="body.dialCode">
						<span v-show="errors.has('dialCode')" class="help is-danger">{{ errors.first('dialCode') }}</span>
					</p>
          </div>-->

        <div class="column">
          <label
            class="label"
            for="country"
          >{{translations.text.country}}/{{$t('region')}}</label>
          <p class="control">
            <span class="select is-fullwidth custom_select">
              <select
                required
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('country') }"
                :data-vv-as="translations.text.country"
                name="country"
                v-model="body.country"
                @change="checkIfIsEuropeanCountry"
              >
                <option value=""></option>
                <option
                  v-for="(item, index) in filteredCountries"
                  :value="index"
                  :key="index"
                >{{item.name}}</option>
              </select>
              <span class="select_placeholder">{{ translations.text.country }}</span>
            </span>
            <span
              v-show="errors.has('country')"
              class="help is-danger"
            >{{ errors.first('country') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="phone"
          >{{translations.text.phone}}</label>
          <div class="control relative">
            <div class="dialcodeBox">{{body.country!=''?body.dialCode:''}}</div>
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('phone'),'push-left':body.country!='' }"
              name="phone"
              type="text"
              :data-vv-as="translations.text.phone"
              :placeholder="translations.text.phone"
              v-model="body.phone"
            />
            <span
              v-show="errors.has('phone')"
              class="help is-danger"
            >{{ errors.first('phone') }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="walletCurrency"
          >{{$t("wallet_currency")}}</label>
          <p class="control">
            <span class="select is-fullwidth custom_select">
              <select
                required
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('walletCurrency') }"
                :data-vv-as="translations.text.walletCurrency"
                name="walletCurrency"
                v-model="body.walletCurrency"
              >

                <!-- <option value disabled>{{ $t('select_currency_label') }}</option> -->
                <!-- <option value selected="selected">{{ $t("select_currency").tTitle() }}</option> -->
                <option
                  v-for="(c, i) in $getCurrencies()"
                  :key="i"
                  :value="i"
                >{{i}} ({{c.symbol}})</option>
              </select>
              <span class="select_placeholder">{{ $t('select_currency_label') }}</span>
            </span>
            <span
              v-show="errors.has('currency')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('currency') }}</span>
          </p>
        </div>
      </div>

      <!-- <h2>{{$t("choose_trading_platform").tUpper()}}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="platform"
          >{{translations.text.platform}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('platform') }"
                :data-vv-as="translations.text.platform"
                name="platform"
                v-model="body.platform"
              >
                <option value>{{translations.text.select_option}}</option>
                <option value="mt4">MT4</option>
              </select>
            </span>
            <span
              v-show="errors.has('platform')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('platform') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="platform"
          >{{translations.text.select_starting_balance}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('startingDemoBalance') }"
                :data-vv-as="translations.text.startingDemoBalance"
                name="startingDemoBalance"
                v-model="body.startingDemoBalance"
              >
                <option value>{{translations.text.select_option}}</option>
                <option value="500">$500</option>
                <option value="1000">$1,000</option>
                <option value="3000">$3,000</option>
                <option value="5000">$5,000</option>
                <option value="20000">$20,000</option>
                <option value="50000">$50,000</option>
                <option value="100000">$100,000</option>
              </select>
            </span>
            <span
              v-show="errors.has('platform')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('platform') }}</span>
          </p>
        </div>
      </div> -->
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="password"
          >{{translations.text.password}}</label>
          <p class="control">
            <input
              v-validate="'required|strong-password|confirmed:confirm_password'"
              :class="{'input': true, 'is-danger': errors.has('password') }"
              name="password"
              type="password"
              :data-vv-as="translations.text.password"
              :placeholder="translations.text.password"
              v-model="body.password"
            />
            <span
              v-show="errors.has('password')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('password') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="confirm_password"
          >{{translations.text.confirm_password}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('confirm_password') }"
              name="confirm_password"
              ref="confirm_password"
              type="password"
              :data-vv-as="translations.text.confirm_password"
              :placeholder="translations.text.confirm_password"
              v-model="body.confirm_password"
            />
            <span
              v-show="errors.has('confirm_password')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('confirm_password') }}</span>
          </p>
        </div>
      </div>

      <div
        class="columns"
        style="margin-bottom:0"
      >
        <div class="column">
          <p
            class="control"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >
            <label class="checkbox">
              <input
                v-validate="''"
                class="agreements"
                :class="{'is-danger': errors.has('include_account_in_bonus_program') }"
                name="tos_with_link"
                type="checkbox"
                :data-vv-as="translations.text.tos_with_link"
                v-model="body.tos_with_link"
              />
              <span class="checkmark"></span>
              <span v-html="translations.text.tos_with_link"></span>
            </label>
            <span
              v-show="errors.has('tos_with_link')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('tos_with_link') }}</span>
          </p>
        </div>
      </div>

      <div
        class="columns"
        style="margin-bottom:0"
      >
        <div class="column">
          <p class="control">
            <label class="checkbox">
              <input
                class="agreements"
                :class="{ 'is-danger': errors.has('agree_terms_marketing') }"
                name="agree_terms_marketing"
                type="checkbox"
                :data-vv-as="translations.text.agree_terms_marketing"
                v-model="body.agree_terms_marketing"
              />
              <span class="checkmark"></span>
              <!-- <span>{{ $t('agree_terms_marketing') }} </span> -->
              <span v-html="translations.text.agree_terms_marketing"></span>
            </label>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <p
            class="control privacy_data_text"
            v-html="translations.text.data_policy_text"
          >
          </p>
        </div>
      </div>

      <a
        class="form_button"
        :class="[isDisabled? 'disabledButton':'']"
        @click="validateCaptcha"
        :disabled="isDisabled"
      >
        <span>{{$t('join').tUpper()}}</span>
      </a>
    </div>
    <div
        v-if="showEUNoticeModal"
        class="modal small EUModal"
        :class="{ 'is-active': showEUNoticeModal }"
      >
        <div class="modal-background"></div>
        <div class="modal-card">
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <h2>{{ $t('important_information') }}</h2>
                <div class="control">
                  <p
                  >{{ $t('important_information_text') }}</p>
                </div>
              </div>
            </div>
            <a
              class="button"
              href="https://my.eurotrader.eu/en/register/demo"
            >{{ $t('continue').tTitle() }}</a>
          </section>
        </div>
      </div>
  </section>
</template>

<script>
// import axios from 'axios'
// import {service} from '../app'
import { mapGetters } from 'vuex'
import config from '../../config'

export default {
  props: ['translations', 'step', 'legalType', 'isLead'],
  data() {
    return {
      isDisabled: false,
      countries: config.countries,
      titles: config.titles,
      hiddenCountries: ['SY', 'IQ', 'AF', 'ER', 'LY', 'SS', 'KP', 'US', 'SD', 'RU', 'CA', 'SO', 'IR', 'TR', 'BE', 'JP', 'MM', 'YE', 'JM', 'HT', 'CD', 'BF', 'BB', 'AL', 'KY', 'ML', 'MZ', 'NG', 'PA', 'PH', 'SN', 'TZ', 'UG', 'CN'],
      body: {
        title: '',
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        dialCode: '',
        phone: '',
        password: '',
        confirm_password: '',
        platform: 'mt4',
        currency: 'usd',
        walletCurrency: '',
        tos_with_link: false,
        agree_terms_marketing: false,
        startingDemoBalance: '10000',
        recaptchaToken: null
      },
      showEUNoticeModal: false,
      recaptcha: null
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
    filteredCountries() {
      for (var i in this.countries) {
        if (this.hiddenCountries.includes(i)) {
          delete this.countries[i]
        }
      }
      return this.countries
    },
  },
  watch: {
    'body.country'(c) {
      this.body.dialCode = '+' + this.countries[c].dialCode
    },
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', this.$t('page_title_demo'), this.$t('demo_account'))
    this.$bus.$on('isLead', this.handleLeadData)
  },
  beforeDestroy() {
    this.$bus.$off('isLead', this.handleLeadData)
  },
  methods: {
    validateCaptcha() {
      this.$recaptchaLoaded()
      this.recaptcha = this.$recaptcha('complete')

      this.recaptcha.then(value => {
        this.complete(value)
      }).catch(err => {
        console.log(err)
      })
    },
    handleLeadData(e) {
      if (!e) {
        return
      }
      let required = ['firstname', 'lastname', 'email', 'country', 'phone']
      for (let v of required) {
        if (typeof this.$route.query[v] !== 'undefined' && typeof this.body[v] !== 'undefined') {
          this.body[v] = this.$route.query[v]
        }
      }
    },
    complete(token) {
      this.body.recaptchaToken = token

      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.body.tos_with_link) {
            this.$toasted.error(this.$t('must_agree_terms'))
            return
          }
          this.isDisabled = true
          this.$bus.$emit('Complete', this.body)
        }
      })
    },
    checkIfIsEuropeanCountry() {
      if (config.EUCountries.includes(this.body.country)) {
        this.showEUNoticeModal = true
        return
      }
      this.showEUNoticeModal = false
    }
  },
}
</script>

<style lang="scss">
@import '../../assets/css/variables';

$demo_purple: #6826f4;
$demo_faded_grey: #c9c9c9;
$demo_semi_white: #f5f5f5;
$demo_dark_color: #10182a;
$demo_pink: #e04ef8;

main.register {
  margin: 40px auto 0;
  @media only screen and (max-width: 768px) {
    background-color: white;
    section#content {
      padding: 0px;
    }
  }
}

.demo .column {
  float: left;
  padding-left: 0;
  @media only screen and (max-width: 1024px) {
    float: none;
    margin: 0 auto;
    width: 90%;
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    padding-left: 0.75rem;
  }
}

.demo .columns {
  margin: 0;
  margin-bottom: calc(1.5rem - 0.75rem);
}

.demo .form-column {
  height: auto;
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 20px #0000001a;
  border-radius: 0px 0px 30px 0px;
  padding: 5%;
  @media only screen and (min-width: 1025px) and (max-width: 1180px) {
    padding: 4%;
  }
  @media only screen and (min-width: 1025px) and (max-width: 1090px) {
    padding: 4%;
  }
  @media only screen and (max-width: 1024px) {
    margin-top: 70px;
  }
  @media only screen and (max-width: 768px) {
    padding: 10px;
    padding-top: 40px;
    margin-bottom: 80px;
  }
}

.sub_inner {
  margin-top: 40%;
  margin-left: 8%;
  h3 {
    margin: 0;
    color: $demo_purple;
    text-align: left;
    font: normal normal 900 42px/34px Roboto;
    margin-bottom: 35px;
  }
  p {
    text-align: left;
    font: normal normal 300 16px/24px Roboto;
    letter-spacing: 0px;
    color: $demo_purple;
    width: 70%;
  }
  @media only screen and (max-width: 1024px) {
    margin-top: 0;
  }
}

.sub_inner ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-top: 60px;
  li {
    text-align: left;
    font: normal normal 300 16px/24px Roboto;
    letter-spacing: 0px;
    color: $demo_purple;
    position: relative;
    padding-left: 18px;
  }
  li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 4px;
    width: 0px;
    height: 0px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 10px solid #ee7a31;
  }
  @media only screen and (max-width: 1024px) {
    margin: 0 auto;
    margin-top: 60px;
    width: 40%;
    min-width: 300px;
  }
}

.content .demo h2.form_title {
  text-align: center;
  font: normal normal 900 44px/36px Roboto;
  letter-spacing: -0.88px;
  color: $demo_dark_color;
  border: 0;
  width: auto;
  margin-bottom: 5px;
  span {
    color: $demo_purple;
  }
  @media only screen and (min-width: 1090px) and (max-width: 1180px) {
    font: normal normal 900 42px/34px Roboto;
  }
  @media only screen and (min-width: 1025px) and (max-width: 1090px) {
    font: normal normal 900 40px/32px Roboto;
  }
  @media only screen and (max-width: 768px) {
    font: normal normal 900 2em/25px Roboto;
  }
  @media only screen and (max-width: 600px) {
    font: normal normal 900 1.7em/25px Roboto;
  }
}

.content .demo p.form_subtitle {
  text-align: center;
  font: normal normal 300 16px/24px Roboto;
  letter-spacing: 0px;
  color: $demo_dark_color;
  margin-bottom: 50px;
}

.step label {
  text-align: left;
  font: normal normal 300 16px/24px Roboto;
  letter-spacing: 0px;
  color: $demo_dark_color;
}

.step input {
  background-image: none !important;
  background: $demo_semi_white 0% 0% no-repeat padding-box;
  border-radius: 5px;
  box-shadow: none;
  border-color: $demo_semi_white;
  color: $demo_dark_color;
  height: 2.6em;
  text-align: left;
  font: normal normal 300 18px/28px Roboto;
  &:hover {
    border-color: $demo_semi_white;
  }
  &:focus {
    outline: none;
    border-color: $demo_purple;
    box-shadow: none;
  }
}

.step input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: $demo_faded_grey;
}
.step input::-moz-placeholder {
  /* Firefox 19+ */
  color: $demo_faded_grey;
}
.step input:-ms-input-placeholder {
  /* IE 10+ */
  color: $demo_faded_grey;
}
.step input:-moz-placeholder {
  /* Firefox 18- */
  color: $demo_faded_grey;
}

.step .select select {
  background: $demo_semi_white 0% 0% no-repeat padding-box;
  border-radius: 5px;
  border-color: $demo_semi_white;
  height: 2.6em;
  color: $demo_dark_color;
  font: normal normal 300 18px/28px Roboto;
  &:focus {
    outline: none;
    border-color: $demo_purple;
    box-shadow: none;
  }
}

.step .select select:invalid,
.step .select select option:invalid,
.step .select select option:disabled {
  color: $demo_faded_grey;
}

.step .select select.is-danger {
  border-color: $red;
}

.step .select + span.is-danger {
  margin-top: 0.95em;
}

.select:not(.is-multiple)::after {
  border-color: $demo_pink;
  height: 0.6em;
  width: 0.6em;
  top: 60%;
}

.step .select select:hover:after {
  border-color: $demo_pink;
}

.step .custom_select {
  height: 2.9em;
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 5px;
  border-color: #f5f5f5;
  z-index: 0;
}

.step .custom_select select {
  background: transparent;
}

.custom_select:not(.is-multiple)::after {
  top: 50%;
}

.step .custom_select .select_placeholder {
  position: absolute;
  left: 10px;
  top: 10px;
  color: $demo_faded_grey;
  z-index: -1;
  font: normal normal 300 18px/28px Roboto;
}

.step .custom_select select option {
  color: $black;
}
.step .custom_select select:valid ~ .select_placeholder {
  opacity: 0;
}

.step label.checkbox {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
}

.step input.agreements {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  height: 24px;
  width: 24px;
  background-color: $demo_semi_white;
  border-radius: 5px;
  flex-shrink: 0;
  position: relative;
}

.step input.agreements:checked ~ .checkmark {
  background-color: $demo_purple;
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.step input.agreements:checked ~ .checkmark:after {
  display: block;
}

.step label.checkbox .checkmark:after {
  left: 9px;
  top: 3px;
  width: 7px;
  height: 14px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.step label.checkbox span:last-child {
  padding-left: 15px;
  text-align: left;
  letter-spacing: 0px;
  color: #7b7c7e;
  font: normal normal 300 12px/14px Roboto;
  display: table;
  line-height: 17px;
  display: inline-block;
}

.step label.checkbox span:last-child a {
  color: #7b7c7e;
  font: normal normal bold 13px/15px Roboto;
  &:hover {
    color: $black;
  }
}

.form_button {
  text-decoration: none;
  display: table;
  margin: 0 auto;
  float: none;
  width: 152px;
  height: 40px;
  background: $demo_purple 0% 0% no-repeat padding-box;
  border-radius: 23px;
  box-shadow: none;
  text-align: center;
  font: normal normal 600 12px/14px Roboto;
  letter-spacing: 0px;
  color: white;
  line-height: 40px;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  &:hover {
    color: white;
    background-color: $demo_pink;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
  }
}

#__lpform_firstname,
#__lpform_password,
#__lpform_confirm_password {
  display: none;
  cursor: default !important;
}

@media only screen and (max-width: 1024px) {
  .sub_inner h3 {
    text-align: center;
  }

  .sub_inner p {
    text-align: center;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 768px) {
  .sub_inner p {
    width: 90%;
  }
}

.step input.push-left {
  padding-left: 63px;
}

.dialcodeBox {
  position: absolute;
  left: 11px;
  top: 9px;
  z-index: 1;
  color: #10182a;
  font: normal normal 300 18px/28px Roboto;
}

.modal.EUModal {
    h2{
      font: normal normal 900 30px/34px Roboto;
      color: #10182a;
      margin-bottom: 30px;
      text-align: left;
      border:0;
      @media only screen and (max-width: 768px) {
          font-size: 25px;
      }
    }
    .modal-card{
      padding: 40px;
      background: #fff;
      border-bottom-right-radius: 30px;
      @media only screen and (max-width: 768px) {
          padding: 0;
      }
      .modal-card-body{
        @media only screen and (max-width: 768px) {
          padding-top: 30px;
          padding-bottom: 40px;
        }
      }
      p{
        text-align: left;
        font: normal normal 300 16px/24px Roboto;
        letter-spacing: 0px;
        color: #10182a;
      }
    }
    .button{
        width: 220px;
        height: 47px;
        background-color: #6826f4;
        border-radius: 23px;
        font: normal normal 400 14px/14px Roboto;
        letter-spacing: 0px;
        margin-top: 20px;
        color: #fff;
        transition: all 0.3s ease-in-out;
    }
}
</style>



// WEBPACK FOOTER //
// Demo.vue?0ee6d067